
import React from 'react';

export function ActivityHeatmap() {
  const months = ['FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN'];

  return (
    <div className="heatmap-container">
      <div className="heatmap-inner">
        <div className="heatmap-months">
          {months.map((month) =>
          <div key={month} className="heatmap-month">
              {month}
            </div>
          )}
        </div>

        <div className="heatmap-grid-container">
          <div className="heatmap-days">
            <span>Mon</span>
            <span>Wed</span>
            <span>Fri</span>
          </div>

          <div className="heatmap-grid">
            {Array.from({ length: 364 }).map((_, i) => {
              const isActive = i === 350;
              return (
                <div
                  key={i}
                  className={`heatmap-cell ${isActive ? 'active' : ''}`}
                  title={`Day ${i}`} />);


            })}
          </div>
        </div>

        <p className="heatmap-note">
          This is based on the attendance of this Employee
        </p>
      </div>
    </div>);

}